module.exports = __webpack_public_path__ + "static/media/championshipWaiting.c6efaa29.svg";